import 
    {   props } from './properties'

export const setDesignationList = (state, payload) => {
    
    state.list = payload

    state.list.push(JSON.parse(JSON.stringify(props)))
    
    let indexNum = 0
    state.list.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/designation/mutations.js